export default [
    {
        path: 'exportacao',
        component: () => import(
            '@/views/atencao-basica/exportacao/Index'
        ),
        redirect: 'exportacao/index',
        children: [
            {
                name: 'atencao-basica-exportacao',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/exportacao/Form'
                ),
            },
        ],
    },
]